
import { Component, Mixins } from "vue-property-decorator";
import {
  getPrepaidReport,
  getPrepaids,
} from "@/repositories/Contracts/PrepaidsRepository";
import FilterableTransactionDetail from "@/components/Base/FilterableTransactionDetail/FilterableTransactionDetail.vue";
import ViewPrepaidsFilter from "@/components/Contracts/Prepaids/ViewPrepaidsFilter.vue";
import Prepaid from "@/interfaces/Contracts/Prepaid";
import FilterableTransactionDetailMixin from "@/mixins/FilterableTransactionDetailMixin";
import AccountMonitorMixin from "@/mixins/AccountMonitorMixin";
import { PrepaidFilter } from "@/interfaces/Contracts/PrepaidFilter";
import { getCurrentDate, getIsoDateString } from "@/helpers/Dates/DateHelpers";
import ViewPrepaidsCardListDetail from "@/components/Contracts/Prepaids/ViewPrepaidsCardListDetail.vue";
import PrepaidsRepoFilter from "@/interfaces/Repository/Contracts/PrepaidsRepoFilter";
import { PredefinedDateRangeType } from "@/enumerations/Dates/DateRangePredefined/PredefinedDateRangeType";
import BaseToolbar from "@/components/Base/Toolbar/BaseToolbar.vue";
import PrepaidStatus from "@/enumerations/Contracts/PrepaidStatus";
import { exportToPDF } from "@/helpers/Export/ExportHelpers";

@Component({
  components: {
    FilterableTransactionDetail,
    ViewPrepaidsFilter,
    ViewPrepaidsCardListDetail,
    BaseToolbar,
  },
})
export default class ViewPrepaids extends Mixins(
  FilterableTransactionDetailMixin,
  AccountMonitorMixin
) {
  prepaids = [] as Prepaid[];
  downloading = false;
  selectedPrepaid: Prepaid | null = null;

  created() {
    this.filter = {
      enteredDateSelection: {
        isCustomDateRange: false,
        predefinedDateRangeTypeValue: PredefinedDateRangeType.AllDates,
        customFromDate: getIsoDateString(getCurrentDate()),
        customEndDate: getIsoDateString(getCurrentDate()),
        repositoryFromDate: getIsoDateString(getCurrentDate()),
        repositoryEndDate: getIsoDateString(getCurrentDate()),
      },
      expireDateSelection: {
        isCustomDateRange: false,
        predefinedDateRangeTypeValue: PredefinedDateRangeType.OneYear,
        customFromDate: getIsoDateString(getCurrentDate()),
        customEndDate: getIsoDateString(getCurrentDate()),
        repositoryFromDate: getIsoDateString(getCurrentDate()),
        repositoryEndDate: getIsoDateString(getCurrentDate()),
      },
      status: PrepaidStatus.outstanding.value,
    } as PrepaidFilter;
  }

  mounted() {
    this.loadData();
  }

  async loadData(): Promise<void> {
    this.loading = true;

    await getPrepaids({
      status: this.filter.status,
      fromEnteredDate: this.filter.enteredDateSelection.repositoryFromDate,
      toEnteredDate: this.filter.enteredDateSelection.repositoryEndDate,
      fromExpireDate: this.filter.expireDateSelection.isCustomDateRange
        ? this.filter.expireDateSelection.customFromDate
        : null,
      toExpireDate: this.filter.expireDateSelection.isCustomDateRange
        ? this.filter.expireDateSelection.customToDate
        : null,
    } as PrepaidsRepoFilter)
      .then((response) => {
        if (response) {
          this.prepaids = response.data;
        }
      })
      .finally(() => (this.loading = false));
  }

  private get disableDownloadPrepaid(): boolean {
    return this.selectedPrepaid === null || this.prepaids.length === 0;
  }

  private async downloadSelectedPrepaid(): Promise<void> {
    if (this.selectedPrepaid === null) return;
    this.downloading = true;

    await getPrepaidReport(this.selectedPrepaid.prepaidId)
      .then((report) =>
        exportToPDF(report.bytes, `Prepaid_${this.selectedPrepaid?.prepaidId}`)
      )
      .finally(() => (this.downloading = false));
  }
}
